import { Component, Input, HostBinding, Output, EventEmitter, OnInit } from '@angular/core';
import { ProgressStep } from './progress-step.interface';


@Component({
  selector: 'suka-progress',
  template: `
    <div class="progress__wrapper">
      <ul class="progress-bar">
        <li
          *ngFor="let step of steps; let i = index"
          class="progress-bar__step"
          [ngClass]="{
            'progress-bar__step--complete': isComplete(step),
            'progress-bar__step--editable': isEditable(step),
            'progress-bar__step--error': step.state === 'error',
            'progress-bar__step--current': step.current,
            'progress-bar__step--unclickable': isUnclickable(step, i)
          }"
        >
          <div class="step" role="button" (click)="select(i)">
            <div class="step__indicator">
              <ng-container *ngIf="step.state !== 'complete' || step.current">{{ i + 1 }}</ng-container>
              <suka-icon icon="check" *ngIf="isComplete(step) && !isEditable(step) && !step.current"></suka-icon>
              <suka-icon icon="edit-2" *ngIf="isEditable(step) && !step.current"></suka-icon>
            </div>
            <span class="step__label"> {{ step.label }}</span>
          </div>
        </li>
      </ul>
    </div>
  `
})
export class Progress {
  private _steps: Array<ProgressStep>;

  @HostBinding('class.progress') baseClass = true;

  @Input() linear = false;
  @Input() editable = false;

  @Output() selected = new EventEmitter();

  @Output() stepsChange = new EventEmitter();
  @Input() get steps() {
    return this._steps;
  }
  set steps(value) {
    this._steps = value;

    this.stepsChange.emit(this._steps);
  }

  select(newIndex): void {
    this._steps.forEach((step, index) => {
      if (index === newIndex) {
        step.current = true;
      } else if(step.current) {
        delete step.current;
      }
    });

    this.selected.emit(newIndex);

    this.steps = this._steps;
  }

  isComplete(step: ProgressStep) {
    return step.state === 'complete';
  }

  isEditable(step: ProgressStep) {
    return step.state === 'complete' && this.editable;
  }

  isUnclickable(step: ProgressStep, index: number): boolean {
    if (step.state === 'complete' && !this.editable) {
      return true;
    }
    if (step.state === 'incomplete' && !this.linear && index !== this.getNextStep()) {
      return true;
    }

    return false;
  }

  getNextStep(): number {
    for (const [index, step] of this.steps.entries()) {
      if (step.state === 'incomplete') {
        return index;
      }
    }

    return -1;
  }
}
